import { useState, useCallback, useEffect, type ReactNode } from 'react';
import { ThemeContext, themes, defaultTheme } from './theme';

const STORAGE_KEY = 'site-theme';

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [themeName, setThemeName] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) ?? 'beige';
    } catch {
      return 'beige';
    }
  });

  const current = themes.find((t) => t.name === themeName) ?? defaultTheme();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', themeName);
    try {
      localStorage.setItem(STORAGE_KEY, themeName);
    } catch {
      /* noop */
    }
  }, [themeName]);

  const setTheme = useCallback((name: string) => {
    if (themes.some((t) => t.name === name)) setThemeName(name);
  }, []);

  const next = useCallback(() => {
    const idx = themes.findIndex((t) => t.name === themeName);
    const nextTheme = themes[(idx + 1) % themes.length];
    if (!nextTheme) throw new Error('themes array must not be empty');
    setThemeName(nextTheme.name);
  }, [themeName]);

  return (
    <ThemeContext.Provider value={{ current, setTheme, next }}>{children}</ThemeContext.Provider>
  );
}
